const getParaText = (inlineNode, objectiveText) => {
  let tempObjectiveText = objectiveText;
  const { nodes: paraNodes } = inlineNode;
  paraNodes.forEach((paraNode) => {
    const { leaves } = paraNode;
    const [documentLeaf] = leaves;
    const { text } = documentLeaf;
    tempObjectiveText += text;
  });
  return tempObjectiveText;
};

export default (params) => {
  const { fieldData } = params;

  const {
    document: { nodes: documentNodes },
  } = fieldData;

  const [objectiveNode] = documentNodes;
  const { nodes: inlineNodes } = objectiveNode;

  /**
   * Remove bullets
   */
  let objectiveText = '';
  inlineNodes.forEach((inlineNode) => {
    if (inlineNode.type === 'paragraph') {
      objectiveText = getParaText(inlineNode, objectiveText);
    } else if (inlineNode.type === 'unordered_list') {
      const { nodes: listItems } = inlineNode;
      listItems.forEach((listItem) => {
        const { nodes: listItemNodes } = listItem;
        listItemNodes.forEach((inlineListItemBlock) => {
          const { type: listItemType } = inlineListItemBlock;
          if (listItemType === 'paragraph') {
            objectiveText = getParaText(inlineListItemBlock, objectiveText);
          }
        });
      });
    }
  });

  const updatedObjective = {
    object: 'value',
    document: {
      object: 'document',
      data: {
        version: {
          number: 3,
          updated: true,
        },
      },
      nodes: [
        {
          object: 'block',
          type: 'objective',
          nodes: [
            {
              object: 'block',
              type: 'paragraph',
              nodes: [
                {
                  object: 'text',
                  leaves: [{ object: 'leaf', text: objectiveText }],
                },
              ],
            },
          ],
        },
      ],
    },
  };

  return { objective: updatedObjective };
};
